export const svgs = {
  logo: 'assets/svgs/logo.svg',
  'logo-small': 'assets/svgs/logo_small.svg',

  'contact-success': 'assets/svgs/contact_success.svg',
  'contact-error': 'assets/svgs/contact_error.svg',

};
